import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
import { AppBar } from '../components/AppBar';
import { Footer } from '../components/Footer';
import { Collections } from '../pages/Collections';
import { Home } from '../pages/Home';
import { NewCollection } from '../pages/NewCollection';

export const DashBoarRouter = () => {
    return (
        <>
            <AppBar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/newCollection" element={<NewCollection />} />
            </Routes>
            <Footer />
        </>
    )
}
